import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
export function OfferAndCTA() {
  return <section id="comprar" className="w-full bg-cream py-20 md:py-32" data-id="element-61">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-white p-8 md:p-12 rounded-sm shadow-xl border border-taupe/20 text-center relative overflow-hidden" data-id="element-63">
          {/* Decorative accents */}
          <div className="absolute top-0 left-0 w-full h-2 bg-terracotta" data-id="element-64"></div>

          <h2 className="text-3xl md:text-4xl font-serif text-text-brown mb-6" data-id="element-65">
            Recupera el control de tu cuerpo hoy mismo.
          </h2>
          <p className="text-lg text-text-brown-light font-light leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-66">
            El Menopause Master-Kit está diseñado para darte resultados
            inmediatos por una fracción de lo que cuesta una sola consulta
            privada.
          </p>

          <div className="mb-10" data-id="element-67">
            <span className="block text-sm font-bold tracking-widest text-gold uppercase mb-2" data-id="element-68">
              Inversión única
            </span>
            <div className="text-6xl md:text-7xl font-serif text-text-brown tracking-tight" data-id="element-69">
              $6.39{' '}
              <span className="text-2xl text-text-brown-light font-sans tracking-normal" data-id="element-70">
                USD
              </span>
            </div>
          </div>

          <motion.a whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} href="https://kitesencial.com/cart/51775891079488:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full sm:w-auto px-10 py-5 text-lg font-medium text-white bg-terracotta hover:bg-[#b56d50] transition-colors duration-300 rounded-sm shadow-md mb-6" data-id="element-71">
            Haz clic aquí para descargar tu Master-Kit
          </motion.a>

          <p className="text-text-brown font-medium mb-6" data-id="element-72">
            y dormir bien esta misma noche.
          </p>

          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-sm text-text-brown-light" data-id="element-73">
            <div className="flex items-center gap-2" data-id="element-74">
              <ShieldCheckIcon className="w-4 h-4 text-gold" data-id="element-75" />
              <span data-id="element-76">Acceso instantáneo</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-77">
              <LockIcon className="w-4 h-4 text-gold" data-id="element-78" />
              <span data-id="element-79">Pago seguro 100%</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}